import React from 'react';
import { Hero } from '../components/Hero';
import { Philosophy } from '../components/Philosophy';
import { Occasions } from '../components/Occasions';
import { Categories } from '../components/Categories';
import { Businesses } from '../components/Businesses';
export function Home() {
  return <>
      <Hero data-id="element-349" data-mp="2x5zcz9im6pji" />
      <Philosophy data-id="element-350" data-mp="2x4eg3d8tuuih" />
      <Occasions data-id="element-351" data-mp="2x4wikrm324yu" />
      <Categories data-id="element-352" data-mp="2x7ipcp15ggg0" />
      <Businesses data-id="element-353" data-mp="1zi7ca5kcl676" />
    </>;
}